import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'

Vue.use(Vuex);

var nameCompareIgnoreCase = function(a, b) {
  var nameA = a.name.toUpperCase(); // ignore upper and lowercase
  var nameB = b.name.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
};

var store = new Vuex.Store({
  state: {
    session: {},
    cities: [],
    contextName: 'Context',
    currentCity: undefined,
    activeAPIRequests: 0,
    softLockContext: {},
    otherUserPageLocks: {},
    currentCityDetails: {},
    currentCityNextWeekend: null
  },
  mutations: {
    setSession (state, newSession) {
      state.session = newSession
    },
    setContextName (state, newContextName) {
      state.contextName = newContextName
    },
    setCurrentCity (state, newCurrentCity) {
      state.currentCity = newCurrentCity
    },
    setActiveAPIRequests(state, newActiveAPIRequestsCount) {
      state.activeAPIRequests = newActiveAPIRequestsCount;
    },
    setSoftLockContext(state, newSoftLockContext) {
      state.softLockContext = newSoftLockContext;
      var otherUserPageLocks = {};
      Object.keys(newSoftLockContext.keys).forEach(key => {
        newSoftLockContext.keys[key].locks.forEach(lock => {
          if (state.session.user && state.session.user.versionedId.id !== lock.userId) {
            var contextLock = otherUserPageLocks[key];
            if (contextLock === undefined) {
              contextLock = {};
              otherUserPageLocks[key] = contextLock;
            }

            var userLock = contextLock[lock.usersName];
            if (userLock === undefined) {
              userLock = {
                timestamps: []
              };
              contextLock[lock.usersName] = userLock;
            }
            userLock.timestamps.push(lock.createTimestamp)
          }
        })
      });
      if (JSON.stringify(state.otherUserPageLocks) !== JSON.stringify(otherUserPageLocks))
        state.otherUserPageLocks = otherUserPageLocks;
    },
    setCities(state, cities) {
      state.cities = cities;
    },
    setCityDetails(state, newCityDetails) {
      state.currentCityDetails = newCityDetails;
      state.currentCityDetails.rooms.sort(nameCompareIgnoreCase);
      state.currentCityDetails.vehicles.sort(nameCompareIgnoreCase);
      state.currentCityDetails.staff.sort(nameCompareIgnoreCase);
      state.currentCityDetails.staff.forEach(staff => {
        if (!staff.color || staff.color.length < 7)
          staff.color = "DEFAULT";
      });
      state.currentCityDetails.courses.sort(nameCompareIgnoreCase);

      var nextWeekend = null;
      var now = new Date();
      if (state.currentCityDetails.weekends) {
        state.currentCityDetails.weekends.forEach(weekend => {
          if (Date.parse(weekend.end + 'T23:59:59') >= now) {
            nextWeekend = weekend;
          }
        })
      }

      state.currentCityNextWeekend = nextWeekend;
    }
  },
  actions: {
    attemptLogin (context, parameters) {
      api.rpcRequest('attemptLogin', {
        u: parameters.username,
        p: parameters.password
      }, session => {}, errorMessage => {})
    }
  }
});

// This seems to work but I'm not sure if it is the right way to do it. We don't have access to the context...
store.attemptLogin = function (username, password, callback) {
  api.rpcRequest('attemptLogin', {
    u: username,
    p: password
  }, message => {
    callback()
    if (message.includes("failed login attempt")) {
      Vue.toasted.error(message, {
        duration: 8000
      });
    } else {
      Vue.toasted.success(message, {
        duration: 8000
      });
    }
  }, errorMessage => {
    callback()
  })
};

store.logout = function () {
  api.rpcRequest('logout', {}, session => {}, errorMessage => {})
};

// DIRECT API CALLS -- These shouldn't modify the global state.
store.api = {};

store.api.rpcRequest = function(method, parameters, successCallback, failureCallback) {
  api.rpcRequest(method, parameters, successCallback, failureCallback);
};

store.api.subscribe = function(topicType, topicId, changeHandler) {
  return api.subscribe(topicType, topicId, changeHandler);
};

store.api.unsubscribe = function(subscriptionId) {
  api.unsubscribe(subscriptionId);
};

store.api.softLock = function(context, key) {
  api.rpcFireAndForget('softLock', {
    context: context,
    key: key
  })
};

store.api.softUnlock = function(context, key) {
  api.rpcFireAndForget('softUnlock', {
    context: context,
    key: key
  })
};

store.api.softUnlockAll = function(context) {
  api.rpcFireAndForget('softUnlockAll', {
    context: context
  })
};

store.api.unlockAllByWebsocketId = function(context) {
  api.rpcFireAndForget('unlockAllByWebsocketId', {})
};

api.setSessionHandler(session => {
  store.commit('setSession', session)
});

api.setRequestCount(count => {
  store.commit('setActiveAPIRequests', count)
});

export default store



// WEBPACK FOOTER //
// ./src/store.js